import { render } from "./domain-deployment.vue?vue&type=template&id=1f51bf10&scoped=true&ts=true"
import script from "./domain-deployment.vue?vue&type=script&lang=ts"
export * from "./domain-deployment.vue?vue&type=script&lang=ts"

import "./domain-deployment.vue?vue&type=style&index=0&id=1f51bf10&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f51bf10"]])

export default __exports__